__turbopack_context__.v({
  "addressLine": "contactUs-module-scss-module__CyQWva__addressLine",
  "addressSection": "contactUs-module-scss-module__CyQWva__addressSection",
  "businessHours": "contactUs-module-scss-module__CyQWva__businessHours",
  "chevron": "contactUs-module-scss-module__CyQWva__chevron",
  "contactInfoDivider": "contactUs-module-scss-module__CyQWva__contactInfoDivider",
  "contactInfoSection": "contactUs-module-scss-module__CyQWva__contactInfoSection",
  "contactUsPage": "contactUs-module-scss-module__CyQWva__contactUsPage",
  "countryCode": "contactUs-module-scss-module__CyQWva__countryCode",
  "emailLink": "contactUs-module-scss-module__CyQWva__emailLink",
  "emailSection": "contactUs-module-scss-module__CyQWva__emailSection",
  "errorText": "contactUs-module-scss-module__CyQWva__errorText",
  "faxLabel": "contactUs-module-scss-module__CyQWva__faxLabel",
  "faxLine": "contactUs-module-scss-module__CyQWva__faxLine",
  "fieldGroup": "contactUs-module-scss-module__CyQWva__fieldGroup",
  "flag": "contactUs-module-scss-module__CyQWva__flag",
  "form": "contactUs-module-scss-module__CyQWva__form",
  "formWrapper": "contactUs-module-scss-module__CyQWva__formWrapper",
  "hoursDay": "contactUs-module-scss-module__CyQWva__hoursDay",
  "hoursTime": "contactUs-module-scss-module__CyQWva__hoursTime",
  "input": "contactUs-module-scss-module__CyQWva__input",
  "inputError": "contactUs-module-scss-module__CyQWva__inputError",
  "phoneDivider": "contactUs-module-scss-module__CyQWva__phoneDivider",
  "phoneInput": "contactUs-module-scss-module__CyQWva__phoneInput",
  "phoneInputWrapper": "contactUs-module-scss-module__CyQWva__phoneInputWrapper",
  "phoneLabel": "contactUs-module-scss-module__CyQWva__phoneLabel",
  "phoneLine": "contactUs-module-scss-module__CyQWva__phoneLine",
  "phoneLink": "contactUs-module-scss-module__CyQWva__phoneLink",
  "phonePrefix": "contactUs-module-scss-module__CyQWva__phonePrefix",
  "phoneRow": "contactUs-module-scss-module__CyQWva__phoneRow",
  "submitButton": "contactUs-module-scss-module__CyQWva__submitButton",
  "textarea": "contactUs-module-scss-module__CyQWva__textarea",
});
